import { render, staticRenderFns } from "./WorkflowStateRequireAttentionMessage.vue?vue&type=template&id=491a2616"
import script from "./WorkflowStateRequireAttentionMessage.vue?vue&type=script&lang=js"
export * from "./WorkflowStateRequireAttentionMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports